import { Routes } from '@angular/router';
import { authGuard } from '@smata-data-access';
import { ROUTE_PATHS } from '@smata-data-shared';
import { SmataLoginComponent, SmataPasscodeComponent } from '@smata-login-page';
import { SmataMainLayoutComponent } from '@smata-shell';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ROUTE_PATHS.login,
  },

  {
    path: ROUTE_PATHS.login,
    component: SmataLoginComponent,
  },
  {
    path: ROUTE_PATHS.passcode,
    component: SmataPasscodeComponent,
  },
  {
    path: '',
    component: SmataMainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: ROUTE_PATHS.purchaseOrders,
        loadChildren: () => import('@feature-purchase-orders').then((m) => m.routes),
      },
    ],
  },

  {
    path: '**',
    redirectTo: ROUTE_PATHS.login,
  },
];
